module.exports = __webpack_public_path__ + "static/img/newdragon.e91e6cc3.jpg";